// ABOUTME: Single source for parsing hypothesis ids ("fig-coe_H1" → category "fig-coe", code "H1")
// ABOUTME: Was duplicated across TranscriptView / detail page / overview — drift here breaks links

export function hypothesisCategory(hypothesisId: string): string {
  return hypothesisId.includes('_') ? hypothesisId.split('_')[0] : hypothesisId
}

export function hypothesisCode(hypothesisId: string): string {
  return hypothesisId.includes('_') ? hypothesisId.split('_').slice(1).join('_') : hypothesisId
}

export function hypothesisPath(hypothesisId: string): string {
  return `/dashboard/hypothesis/${hypothesisCategory(hypothesisId)}/${hypothesisId}`
}
